export default "__VITE_ASSET__V$0JG4fQ__"